import React from 'react';
import ServicePage from './ServicePage';

export default function GreenlineCarpentry() {
  return (
    <ServicePage
      category="carpentry"
      eyebrow="03 · Carpentry"
      title={<>Custom carpentry <em className="not-italic" style={{ color: 'var(--gl-primary)' }}>& built-ins.</em></>}
      intro="The finish work is what you actually touch every day. We obsess over the joints, the reveals, and the way a drawer glides shut."
      description="Built-in shelving and window seats, trim and crown molding, custom closets, mudroom lockers, fireplace mantels, stair railings, decks, and exterior trim. Whether it's one statement built-in for the living room or finish carpentry throughout a whole remodel, we mill and install woodwork that fits your home like it was always there — tight seams, clean lines, and finishes built to last."
    />
  );
}
